
<template>
  <div class="submit" v-if="assetsConfig">
    <NavigationBar :title="assetsConfig.title"></NavigationBar>
    <img
      :src="assetsConfig.submit_screen && assetsConfig.submit_screen.header_bk"
      class="submit__back"
      :style="{
        marginTop: $isHideNavbar ? 0 : $pxToVw(88),
      }"
    />
    <!-- 信息提交 -->
    <div class="submit__form">
      <div class="submit__field-box flex">
        <span class="submit__field-title">姓名</span>
        <VantField
          class="submit__field"
          placeholder="请输入姓名"
          @input="handleNameInput"
          @formatter="formatter"
          v-model="submitInfo.realname"
          maxlength="20"
        ></VantField>
      </div>
      <div class="submit__field-box flex">
        <span class="submit__field-title">手机号码</span>
        <VantField
          ref="phoneRef"
          class="submit__field"
          placeholder="请输入手机号码"
          type="tel"
          v-model="submitInfo.mobile"
        ></VantField>
      </div>
      <div class="submit__field-box flex" v-if="!isHidePhone">
        <span class="submit__field-title">验证码</span>
        <div class="submit__code flex">
          <VantField
            ref="codeRef"
            class="submit__code--input"
            placeholder="请输入验证码"
            type="telCode"
            v-model="submitInfo.sms_code"
          />
          <div
            class="main-code-btn"
            :class="!canSendCode && 'main-code-btn--disabled'"
            @click="handleClickCode"
            >
            <span>{{canSendCode ? "获取验证码" : `${seconds}s重新获取`}}</span>
          </div>
        </div>
      </div>
      <div class="submit__field-box flex">
        <span class="submit__field-title">申请开店省份</span>
        <VantField
          class="submit__field"
          placeholder="请选择省份"
          readonly
          right-icon="arrow-down"
          @click="handleShowAreaPopup(1)"
          v-model="submitInfo.province"
        ></VantField>
      </div>
      <div class="submit__field-box flex">
        <span class="submit__field-title">申请开店城市</span>
        <VantField
          class="submit__field"
          placeholder="请选择城市"
          right-icon="arrow-down"
          @click="handleShowAreaPopup(2)"
          readonly
          v-model="submitInfo.city"
        ></VantField>
      </div>
      <div class="submit__field-box flex">
        <span class="submit__field-title">申请开店区县</span>
        <VantField
          class="submit__field"
          placeholder="请选择区县"
          right-icon="arrow-down"
          v-model="submitInfo.quxian"
          readonly
          @click="handleShowAreaPopup(2)"
        ></VantField>
      </div>
      <div
        class="main-btn flex"
        :class="(!canSubmit || isSubmiting) && 'main-btn--disabled'"
        @click="handleClickSubmit"
        :style="{
          color: assetsConfig.submit_screen.btn_color,
          backgroundColor: assetsConfig.submit_screen.btn_bk_color,
        }"
      >
        <VantLoading color="#fff" v-if="isSubmiting"></VantLoading>
        <span v-else>{{
          assetsConfig.submit_screen.btn_title || "提交申请"
        }}</span>
      </div>

      <div
        class="submit__privacy flex"
        :class="shakePrivacy && 'shake-animation'"
        @click.stop="isAgreePrivacy = !isAgreePrivacy"
      >
        <img
          :src="
            assetsConfig.submit_screen.privacy_checkbox_icon ||
            require('../../assets/imgs/icon-radio.png')
          "
          class="submit__radio"
          v-show="!isAgreePrivacy"
        />
        <img
          :src="
            assetsConfig.submit_screen.privacy_checkbox_icon_select ||
            require('../../assets/imgs/icon-radio-checked.png')
          "
          class="submit__radio"
          v-show="isAgreePrivacy"
        />
        <div class="submit__privacy-txt">
          我已阅读并同意
          <span
            class="submit__privacy-name"
            :style="{
              color:
                assetsConfig.submit_screen.privacy_title_color || '#009602',
            }"
            @click.stop="handleClickShowPrivacyPopup"
            >{{
              assetsConfig.submit_screen.privacy_text || "《个人信息保护政策》"
            }}</span
          >
        </div>
      </div>
    </div>

    <!-- 验证码弹窗 -->
    <VantPopup v-model="isShowVerifyPopup" position="center" round>
      <VerifyWindow
        :color="assetsConfig.submit_screen.btn_color"
        :backgroundColor="assetsConfig.submit_screen.btn_bk_color"
        v-if="isShowVerifyPopup"
        @onconfirm="handleVerifyCoderConfirm"
      ></VerifyWindow>
    </VantPopup>

    <!-- 省市选择 -->
    <VantPopup
      v-model="isShowAreaSelectPopup"
      position="bottom"
      round
      :style="{ minHeight: '60%' }"
      safe-area-inset-bottom
    >
      <VantLoading
        class="center"
        color="#111"
        v-if="isLoadingAreaData"
      ></VantLoading>
      <VantCascader
        v-else
        class="area-select"
        :active-color="assetsConfig.submit_screen.btn_bk_color || '#009602'"
        :options="areaList"
        @close="isShowAreaSelectPopup = false"
        @finish="handleFinshAreaSelect"
      ></VantCascader>
    </VantPopup>

    <!-- 信息提交成功提示 -->
    <VantPopup
      v-model="isShowSubmitSuccessPopup"
      position="center"
      round
      @closed="handlePageBack"
    >
      <div class="submit__success-pop">
        <div class="submit__success-title-box flex">
          <img
            src="../../assets/imgs/icon-success.png"
            class="submit__success-title-img"
          />
          <div class="submit__success-title">提交成功！</div>
        </div>
        <div class="submit__success-desc">
          请保持手机畅通， <br />工作人员会在5天内联系
        </div>
        <div
          class="main-btn btn-back"
          :style="{
            color: assetsConfig.submit_screen.btn_bk_color,
            borderColor: assetsConfig.submit_screen.btn_bk_color,
          }"
          @click="handlePageBack"
        >
          返回
        </div>
      </div>
    </VantPopup>
    <!-- 信息二次提交提示 -->
    <VantPopup
      v-model="isShowSecondSubmitPopup"
      position="center"
      round
      @closed="handlePageBack"
    >
      <div class="submit__fail-pop">
        <div class="submit__fail-desc">
          您已提交过申请，无需二次提交~ <br />稍后将有业务人员与您联系，请耐心等待
        </div>
        <div
          class="main-btn btn-back"
          :style="{
            color: assetsConfig.submit_screen.btn_bk_color,
            borderColor: assetsConfig.submit_screen.btn_bk_color,
          }"
          @click="handlePageBack"
        >
          确认
        </div>
      </div>
    </VantPopup>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  Form,
  Field,
  Button,
  Popup,
  Toast,
  Loading,
  Picker,
  Cascader,
} from "vant";
import Util from "../../util";
import VerifyWindow from "../../components/verifyWindow";
import NavigationBar from "../../components/navigationBar";

// 开发模式本地地址
const DURATION = 1500;

export default {
  data() {
    return {
      // 首页资源配置
      assetsConfig: "",
      isAgreePrivacy: false,
      isShowVerifyPopup: false,
      isShowAreaSelectPopup: false,
      isShowSubmitSuccessPopup: false,
      isShowSecondSubmitPopup: false,
      isLoadingAreaData: false,
      isSubmiting: false,
      canSendCode: true,
      seconds: 60,
      uuid: "",
      shakePrivacy: false,
      submitInfo: {
        realname: "",
        mobile: "",
        sms_code: "",
        province: "",
        city: "",
        quxian: "",
        area_id: "",
      },
      //   品牌：0德克士，1贝瑞，2康师傅
      brand: 0,
      captcha: "",
      session_key: "",
      channel: "",
      areaList: [],
      fieldNames: {
        text: "text",
        value: "value",
        children: "children",
      },
      isHidePhone: window.channelId === '005',
    };
  },
  created() {
    window.OnConfigFnc((getConfig) => {
      const Config = getConfig(window.brand) || "";
      if (!Config || !Config.submit_screen) {
        this.$router.replace({ path: "./empty", query: this.$route.query });
        return;
      }
      this.assetsConfig = Config;
    });

    const _brands = {
      dicos: "0",
      belray: "1",
      masterkongchef: "2",
    };
    this.brand = _brands[window.brand] || "0";
  },
  computed: {
    canSubmit() {
      let _canSubmit = true;
      //   遍历提交数据中是否有空
      for (
        let index = 0;
        index < Object.keys(this.submitInfo).length;
        index += 1
      ) {
        const key = Object.keys(this.submitInfo)[index];
        if (Util.isEmptyString(this.submitInfo[key]) && !this.isHidePhone || (this.isHidePhone && Util.isEmptyString(this.submitInfo[key]) && (key != "sms_code"))) {
          _canSubmit = false;
          break;
        }
      }
      //   手机是否合法
      //   if (_canSubmit && !Util.isValidPhoneNumber(this.submitInfo.mobile)) {
      //     _canSubmit = false;
      //   }
      return _canSubmit;
    },
  },
  methods: {
    handleFinshAreaSelect({ selectedOptions }) {
      //   console.log("placeholder: ", selectedOptions);
      this.isShowAreaSelectPopup = false;
      if (Array.isArray(selectedOptions) && selectedOptions.length > 0) {
        this.submitInfo.province = selectedOptions[0].text;
        if (selectedOptions.length > 1) {
          this.submitInfo.city = selectedOptions[1].text;
          if (selectedOptions.length > 2) {
            this.submitInfo.quxian = selectedOptions[2].text;
            this.submitInfo.area_id = selectedOptions[2].value;
          }
        }
      }
    },
    async getAreaData() {
      this.isLoadingAreaData = true;
      const [err, res] = await window.httpWrap(window.vsApi.getAreaList({}));
      if (!res || err || res.retcode !== 200) {
        this.isLoadingAreaData = false;
        Toast({
          message: err.msg || res.msg || "获取地址信息失败",
          duration: DURATION,
        });
        return;
      }
      this.areaList = Util.fomartAreaDataToVant(res.data.list);
      //   console.log("placeholder: ", this.areaList);
      this.isLoadingAreaData = false;
    },
    async handleClickCode() {
      if (this.submitInfo.mobile.length !== 11) return;
      if (!this.canSendCode) {
        return;
      }
      //todo: 发送验证码接口
      this.canSendCode = false;
      const [err, res] = await window.httpWrap(
        window.vsApi.getSendCode({
          data: {
            mobile: this.submitInfo.mobile,
            valid_mode: "unlimited",
            brand: this.brand,
          },
        })
      );
      if (!res || err || res.retcode !== 200) {
        Toast({
          message: "获取验证码失败，请重试",
          duration: DURATION,
        });
        return;
      } else {
        this.uuid = res.data.uuid;
        Toast({
          message: "验证码已发送",
          duration: DURATION,
        });
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => { // 使用箭头函数确保this的正确绑定
          this.seconds -= 1;
          if (this.seconds <= 0) {
              clearInterval(this.timer); // 倒计时结束后清除定时器
              this.seconds = 60; // 重置秒数
              this.canSendCode = true;
          }
      }, 1000);
    },
    handleClickSubmit() {
      if (this.isSubmiting) return;
      if (!this.canSubmit) {
        Toast({
          message: "请完成全部信息填写后提交",
          duration: DURATION,
        });
        return;
      }
      if (!Util.isValidPhoneNumber(this.submitInfo.mobile)) {
        this.$refs.phoneRef.focus();
        Toast({
          message: "请输入正确手机号",
          duration: DURATION,
        });
        return;
      }
      if (this.submitInfo.sms_code.length !== 6 && !this.isHidePhone) {
        this.$refs.codeRef.focus();
        Toast({
          message: "请输入6位验证码",
          duration: DURATION,
        });
        return;
      }
      if (!this.isAgreePrivacy) {
        Toast({
          message: "请阅读并勾选同意协议",
          duration: DURATION,
        });
        this.shakePrivacy = true;
        setTimeout(() => {
          this.shakePrivacy = false;
        }, DURATION);
        return;
      }
      this.isShowVerifyPopup = true;
    },
    handleVerifyCoderConfirm(e) {
      this.isShowVerifyPopup = false;
      this.captcha = e.captcha;
      this.session_key = e.session;
      this.doSubmitInfo();
    },
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/\d/g, "");
    },
    handleNameInput(e) {
      const regex = /[^\u4e00-\u9fa5a-zA-Z]/g; // 匹配非汉字和字母字符
      this.submitInfo.realname = e.replace(regex, "");
      if (!this.isChineseOrLetter(e)) {
        Toast({
          message: "仅限文字和字母",
          duration: DURATION,
        });
      }
    },
    isChineseOrLetter(str) {
      // 使用正则表达式匹配汉字和字母
      const pattern = /^[\u4E00-\u9FFFa-zA-Z]+$/;
      return pattern.test(str);
    },
    async doSubmitInfo() {
      this.isSubmiting = true;
      //   console.log("placeholder: brand", this.brand);
      //   console.log("placeholder: captcha", this.captcha);
      //   console.log("placeholder: session_key", this.session_key);
      //   console.log("placeholder: submitInfo", this.submitInfo);
      //   { data: { machineNo: params.machineNo } }
      const [err, res] = await window.httpWrap(
        window.vsApi.submitJoinInfo({
          data: {
            brand: this.brand,
            captcha: this.captcha,
            session_key: this.session_key,
            channel: window.channelId,
            uuid: this.uuid,
            ...this.submitInfo,
          },
        })
      );
      if (!res || err || res.retcode !== 200) {
        this.isSubmiting = false;
        if (err.retcode === 40163) {
          this.isShowSecondSubmitPopup = true;
          return;
        }
        Toast({
          message: err.msg || res.msg || "提交失败，请重试",
          duration: DURATION,
        });
        return;
      }
      this.isShowSubmitSuccessPopup = true;
      this.isSubmiting = false;
      window.sensors.track("SubmitJoinForm", {});
    },
    handleClickShowPrivacyPopup() {
      //   window.open(this.assetsConfig.submit_screen.privacy_link);
      //   window.location.href = this.assetsConfig.submit_screen.privacy_link;

      this.$router.push({
        path: "./webview",
        query: { href: this.assetsConfig.submit_screen.privacy_link },
      });
    },
    handleShowAreaPopup(type) {
      this.isShowAreaSelectPopup = true;
      if (this.areaList.length === 0) this.getAreaData();
    },

    handleCancelArea() {
      this.isShowAreaSelectPopup = false;
    },
    handleConfirmArea(items, indexs) {
      if (Array.isArray(indexs) && indexs.length > 0) {
        const _province = this.areaList[indexs[0]];
        if (indexs.length > 1) {
          const _city = _province.children[indexs[1]];
          if (indexs.length > 2) {
            const _area = _city.children[indexs[2]];
            this.submitInfo.province = _province.text;
            this.submitInfo.city = _city.text;
            this.submitInfo.quxian = _area.text;
            this.submitInfo.area_id = _area.value;
            this.isShowAreaSelectPopup = false;
          }
        }
      }
    },
    handlePageBack() {
      this.isShowSubmitSuccessPopup = false;
      this.isShowSecondSubmitPopup = false;
      for (
        let index = 0;
        index < Object.keys(this.submitInfo).length;
        index += 1
      ) {
        const key = Object.keys(this.submitInfo)[index];
        this.submitInfo[key] = "";
      }
      this.captcha = "";
      this.session_key = "";
      this.$router.back();
    },
  },
  components: {
    VantForm: Form,
    VantField: Field,
    VantButton: Button,
    VantPopup: Popup,
    VantLoading: Loading,
    VerifyWindow,
    VantPicker: Picker,
    VantCascader: Cascader,
    NavigationBar,
  },
};
</script>

<style lang="scss" scoped>
  .submit {
    width: 100%;
    height: 100vh;
    background-color: white;
    overflow-x: hidden;
    overflow-y: auto;
    &__back {
      width: 100%;
      height: 612px;
      margin-top: 88px;
    }
    &__form {
      width: 686px;
      //   height: 794px;
      background-color: #ffffff;
      box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.11);
      border-radius: 32px;
      position: relative;
      margin: -280px auto 138px;
      padding: 46px 32px 48px;
    }
    .main-btn {
      width: 466px;
      margin-top: 66px;
      justify-content: center;
    }
    .main-code-btn {
      justify-content: center;
      background-color: #009602;
      color: white;
      font-size: 20px;
      padding: 10px 15px;
      border-radius: 10px;

      &--disabled {
        background-color: #e2e2e2;
      }
    }
    &__field-box {
      margin-bottom: 24px;
    }
    &__field-title {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      position: relative;
      &::before {
        content: "*";
        height: 36px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e53a0b;
        line-height: 36px;
      }
    }
    &__field {
      width: 413px;
      height: 84px;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      border-radius: 12px;
      border: 2px solid #e2e2e2;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }

    &__code {
      height: 84px;
      width: 413px;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      border-radius: 12px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;

      &--input {
        width: 233px;
        height: 84px;
        display: flex;
        align-items: center;
        background-color: #ffffff;
        border-radius: 12px;
        border: 2px solid #e2e2e2;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
      }
    }

    &__privacy {
      justify-content: center;
      margin: 46px auto 0;
    }
    &__radio {
      width: 40px;
      height: 40px;
      margin-right: 6px;
    }
    &__privacy-txt {
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
    }
    &__privacy-pop-info {
      padding: 40px 30px;
    }
    &__success-pop {
      width: 580px;
      height: 498px;
      background-color: #ffffff;
      border-radius: 24px;
      padding: 76px 0;
    }
    &__success-title-box {
      justify-content: center;
    }
    &__success-title-img {
      width: 88px;
      height: 88px;
      margin-right: 8px;
    }
    &__success-title {
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
    }
    &__success-desc {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
      margin: 22px auto 60px;
    }
    &__fail-pop {
      width: 580px;
      height: 408px;
      background-color: #ffffff;
      border-radius: 24px;
      padding: 76px 0;
    }
    &__fail-desc {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
      margin: 22px auto 60px;
    }
    .btn-back {
      width: 336px;
      height: 84px;
      line-height: 84px;
      border-radius: 48px;
      background-color: white;
      border: 2px solid #009602;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #009602;
    }
    .shake-animation {
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0 0);
      }

      20%,
      80% {
        transform: translate3d(4px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-6px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(2px, 0, 0);
      }
    }
  }
</style>
<style lang="scss">
  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .area-select {
    .van-loading__spinner--circular {
      width: 80px;
      height: 80px;
    }
    .van-loading__circular {
      color: #aaa;
    }
  }
</style>